import React from "react";

const Subscribe = () => {
  return (
    <div className="flex flex-col items-center justify-center flex-auto w-full pb-10 text-md">
      <span className="w-5/6 p-4 mb-5 font-light rounded-lg shadow-lg bg-gray-50 bg-opacity-80 backdrop-filter backdrop-blur-lg">
        <span className="font-normal">Total Experience:</span> 4.5 years
      </span>
      <span className="w-5/6 p-4 mb-5 font-light rounded-lg shadow-lg bg-gray-50 bg-opacity-80 backdrop-filter backdrop-blur-lg">
        <span className="font-normal">Tech Stack:</span> MERN , GraphQL
      </span>
      <span className="w-5/6 p-4 mb-5 font-light rounded-lg shadow-lg bg-gray-50 bg-opacity-80 backdrop-filter backdrop-blur-lg">
        <span className="font-normal">Current Company:</span> Reliance Jio
      </span>
      <span className="w-5/6 p-4 mb-5 font-light rounded-lg shadow-lg bg-gray-50 bg-opacity-80 backdrop-filter backdrop-blur-lg">
        <span className="font-normal">Profile:</span> Senior Software Engineer
      </span>
      <span className="w-5/6 p-4 mb-5 font-light rounded-lg shadow-lg bg-gray-50 bg-opacity-80 backdrop-filter backdrop-blur-lg">
        <span className="font-normal">Other Tech skills:</span> .NET, SQL
        Server, Wordpress, Android, Java, Selenium, Arduino, Python
      </span>
      <span className="w-5/6 p-4 mb-5 font-light rounded-lg shadow-lg bg-gray-50 bg-opacity-80 backdrop-filter backdrop-blur-lg">
        <span className="font-normal">Hobbies:</span> Trekking, Yoga, Football,
        Table-tennis, Gardening, Binge-watching
      </span>
    </div>
  );
};
export default Subscribe;
